export default class ServiceConfig {
    daysToDeleteFilesMax: number | null = null;
    daysToDeleteFileDefault: number | null = null;
    daysToDeleteUnusedTicketsMax: number | null = null;
    daysToDeleteUnusedTicketsDefault: number | null = null;
    daysToBeValidForTicketsMax: number | null = null;
    daysToBeValidForTicketsDefault: number | null = null;
    daysToKeepLogs: number | null = null;
    daysToKeepFileLogs: number | null = null;
    hoursForOTPToBeValid: number | null = null;
    daysToRemindBeforeDeletion: number | null = null;
    limitOfAttempts: number | null = null;
    defaultOfAttempts: number | null = null;

    constructor(data: Record<string, any> | undefined = undefined) {
        Object.assign(this, data);
    }
}